export default (eventHub, { enabled }, store) => {
  if (enabled && typeof window !== 'undefined' && window.fbq) {
    eventHub.$on('eventReport', ({ event, ecommerce, wine_club, ...data }) => {
      if (!ecommerce) ecommerce = {}
      ecommerce.currency = store.getters['ecommerce/getConfigItem']('currency') || 'AUD'

      if (event === 'add_to_cart') {
        window.fbq('track', 'AddToCart', {
          content_ids: [ecommerce.item_id],
          content_name: ecommerce.item_name,
          content_type: 'product',
          contents: [{
            id: ecommerce.item_id,
            name: ecommerce.item_name,
            product_type: ecommerce.product_type,
            wine_type: ecommerce.wine_type,
            wine_series: ecommerce.wine_series,
            wine_varietal: ecommerce.wine_varietal,
            sku: ecommerce.sku,
            sweetness: ecommerce.sweetness,
            bottle_size: ecommerce.bottle_size,
            vintage: ecommerce.vintage,
            wine_body: ecommerce.wine_body,
            price: ecommerce.price,
            quantity: ecommerce.row_total
          }],
          currency: ecommerce.currency,
          value: ecommerce.price * (ecommerce.qty || 1)
        })
      }
      if (event === 'createAccountOnCheckout') {
        window.fbq('track', 'CompleteRegistration', {
          content_name: 'signup',
          currency: ecommerce.currency,
          status: true,
          value: 0
        })
      }
      if (event === 'wine_club_selection') {
        window.fbq('track', 'CompleteRegistration', {
          content_name: `${wine_club.club_name}: ${wine_club.delivery_frequency}`,
          currency: ecommerce.currency,
          status: true,
          value: wine_club.total
        })
      }

      if (event === 'checkout_options') {
        const content_ids = []
        const contents = []
        let num_items = 0
        for (const item of Object.values(ecommerce.items)) {
          const baseItem = store.getters['products/findProductByID'](item.item_id ?? item.nid)
          content_ids.push(baseItem.nid)
          contents.push({
            id: baseItem.nid,
            name: baseItem.title,
            product_type: baseItem.product_type,
            wine_type: baseItem.wine_type,
            wine_series: baseItem.series,
            wine_varietal: baseItem.varietal,
            sku: baseItem.sku,
            sweetness: baseItem.sweetness,
            bottle_size: baseItem.bottle_size,
            vintage: baseItem.vintage,
            wine_body: baseItem.wine_body,
            price: item.price,
            quantity: item.qty
          })
          num_items += item.qty
        }

        window.fbq('track', 'InitiateCheckout', {
          content_category: 'checkout',
          content_ids,
          contents,
          currency: ecommerce.currency,
          num_items,
          value: ecommerce.total
        })
      }

      if (event === 'view_wine') {
        window.fbq('track', 'ViewContent', {
          content_category: 'view',
          content_ids: [ecommerce.item_id],
          content_name: ecommerce.item_name,
          content_type: 'product',
          contents: [{
            id: ecommerce.item_id,
            name: ecommerce.item_name,
            product_type: ecommerce.product_type,
            wine_type: ecommerce.wine_type,
            wine_series: ecommerce.wine_series,
            wine_varietal: ecommerce.wine_varietal,
            sku: ecommerce.sku,
            sweetness: ecommerce.sweetness,
            bottle_size: ecommerce.bottle_size,
            vintage: ecommerce.vintage,
            wine_body: ecommerce.wine_body,
            price: ecommerce.price,
            quantity: 0
          }],
          currency: ecommerce.currency,
          value: ecommerce.price
        })
      }

      if (event === 'purchase_paid') {
        const content_ids = []
        const contents = []
        let num_items = 0
        for (const item of Object.values(ecommerce.items)) {
          const baseItem = store.getters['products/findProductByID'](item.item_id ?? item.nid)
          content_ids.push(baseItem.nid)
          contents.push({
            id: baseItem.nid,
            name: baseItem.title,
            product_type: baseItem.product_type,
            wine_type: baseItem.wine_type,
            wine_series: baseItem.series,
            wine_varietal: baseItem.varietal,
            sku: baseItem.sku,
            sweetness: baseItem.sweetness,
            bottle_size: baseItem.bottle_size,
            vintage: baseItem.vintage,
            wine_body: baseItem.wine_body,
            price: item.price,
            quantity: item.qty
          })
          num_items += item.qty
        }

        window.fbq('track', 'Purchase', {
          content_category: 'checkout',
          content_ids,
          content_name: 'checkout',
          content_type: 'product',
          contents,
          currency: ecommerce.currency,
          num_items,
          value: ecommerce.total
        })
      }
    })
  }
}
